import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    LoadingProgress,
    Panel,
    Switch,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import { useFormActions, useForm, useMeta, useValidator } from "@/hooks";
import {
    MUTATION_UPDATE_SURFSIDE,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const SurfsideForm = ({ app }) => {
    const { user } = useMeta();
    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    const options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                id: inputs.id,
                active: inputs.active,
                account_id: inputs.account_id,
                source_id: inputs.source_id,
                channel_id: inputs.channel_id,
                type: "Surfside",
            },
        },
    };

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "id",
                method: "isEmpty",
                validWhen: false,
                message: "This app id is required.",
            },
            {
                field: "account_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Account id is required.",
            },
            {
                field: "source_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Source id is required.",
            },
            {
                field: "channel_id",
                method: "isEmpty",
                validWhen: false,
                message: "This Merchant id is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "Surfside",
        "",
        MUTATION_UPDATE_SURFSIDE,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "primary",
    );

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>Surfside</Heading>
                        <Text tone="secondary" variant="body-sm">
                            Surfside Information
                        </Text>
                    </div>
                    <HeaderActions
                        actions={[
                            {
                                id: "update",
                                label: "Update",
                                icon: loading ? undefined : <SaveIcon />,
                                loading,
                                disabled: loading,
                                onClick: () => createOrUpdate(),
                            },
                        ]}
                        aria-label="Surfside actions"
                    />
                </div>
            }
            showHeaderDivider
        >
            {user.loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        <Switch
                            checked={Boolean(inputs.active)}
                            label="Active"
                            name="active"
                            onChange={inputChange}
                        />
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, "account_id")}
                                fullWidth
                                label="Account Id"
                                name="account_id"
                                onChange={inputChange}
                                value={inputs.account_id || ""}
                            />
                        </FormLayout.Grid>
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, "source_id")}
                                fullWidth
                                label="Source Id"
                                name="source_id"
                                onChange={inputChange}
                                value={inputs.source_id || ""}
                            />
                            <Input
                                error={fieldError(validator, "channel_id")}
                                fullWidth
                                label="Channel Id"
                                name="channel_id"
                                onChange={inputChange}
                                value={inputs.channel_id || ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default SurfsideForm;
